import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'excerpt'
})
export class ExcerptPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if(!value){
      return '';
    }

    return String.prototype.slice.apply(value, [0, args]) + '...';
  }

}
